import React from "react";
import R14, {
  Text,
  View,
  Image,
} from "../core";
import Touchable from "./TouchableComponent";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { customCommonStyles } from "../assets/css/customCommonStyle";

import arrowLeft from "../assets/images/icPrevious.png";
import arrowRight from "../assets/images/icNext.png";
import arrowFirst from "../assets/images/icFirst.png";
import arrowLast from "../assets/images/icLast.png";

export default R14.connect(
  class TableListComponent extends React.Component {

    async getFirst() {
      return await this.props.initializer(1);
    }

    getNext = async () => {
      let { page, totalRows, rowsPerPage } = this.props;
      const totalPages = Math.ceil(totalRows / rowsPerPage);
      if (page <= totalPages) {
        page = page + 1;
        await this.props.initializer(page);
      };
      return false;
    }

    async getPrevious() {
      const { page } = this.props;
      if (page > 1) return await this.props.initializer(page - 1);
    }

    getLast = async () => {
      let { totalRows, rowsPerPage } = this.props;
      const page = Math.ceil(totalRows / rowsPerPage);
      return await this.props.initializer(page);
    }

    render() {
      const {
        totalRows,
        page,
        rowsPerPage,
      } = this.props;

      const pagination = totalRows > rowsPerPage;
      const totalPages = Math.ceil(totalRows / rowsPerPage);
      let startIndex = ((page - 1) * rowsPerPage) + 1;
      let endIndex = totalRows < page * rowsPerPage ? totalRows : page * rowsPerPage;
      let rowItems = endIndex - startIndex + 1;
      return (
        <>
          {/* Pagination Starts */}
          {!!pagination ?
            <View style={[commonStyles.flex1, commonStyles.customFlexDirection, commonStyles.paginationWrap, commonStyles.flexGrow0, customCommonStyles.customPaginationWrap, commonStyles.marginBottom16]}>

              <View style={[commonStyles.flex1, commonStyles.justifyContentFlexEnd, commonStyles.flexDirectionRow, commonStyles.paginationInnerWrap, commonStyles.flexGrow0]}>
                <View>
                  <Touchable style={[page === 1 ? commonStyles.disabledInput : null]}
                    onPress={() => this.getFirst()} disabled={page === 1}>
                    <View style={[commonStyles.flex1, commonStyles.flexGrow0, commonStyles.alignItemsCenter, commonStyles.justifyContentCenter, customCommonStyles.paginationBtnWidth, page === 1 ? commonStyles.disabledInput : null]}>
                      <Image source={arrowFirst} style={commonStyles.icon20} />
                    </View>
                  </Touchable>
                </View>
                <View>
                  <Touchable style={[page === 1 ? commonStyles.disabledInput : null]}
                    onPress={() => this.getPrevious()} disabled={page === 1}>
                    <View style={[commonStyles.flex1, commonStyles.flexGrow0, commonStyles.alignItemsCenter, commonStyles.justifyContentCenter, customCommonStyles.paginationBtnWidth, page === 1 ? commonStyles.disabledInput : null]}>
                      <Image source={arrowLeft} style={commonStyles.icon20} />
                    </View>
                  </Touchable>
                </View>
                <View>
                  <Touchable style={[page === totalPages ? commonStyles.disabledInput : null]}
                    onPress={() => this.getNext()} disabled={page === totalPages}>
                    <View style={[commonStyles.flex1, commonStyles.flexGrow0, commonStyles.alignItemsCenter, commonStyles.justifyContentCenter, customCommonStyles.paginationBtnWidth, page === totalPages ? commonStyles.disabledInput : null]}>
                      <Image source={arrowRight} style={commonStyles.icon20} />
                    </View>
                  </Touchable>
                </View>
                <View>
                  <Touchable style={[page === totalPages ? commonStyles.disabledInput : null]}
                    onPress={() => this.getLast()} disabled={page === totalPages}>
                    <View style={[commonStyles.flex1, commonStyles.flexGrow0, commonStyles.alignItemsCenter, commonStyles.justifyContentCenter, customCommonStyles.paginationBtnWidth, page === totalPages ? commonStyles.disabledInput : null]}>
                      <Image source={arrowLast} style={commonStyles.icon20} />
                    </View>
                  </Touchable>
                </View>
              </View>

              <View style={[commonStyles.rowPerPage, commonStyles.marLt0, commonStyles.marginTop10]}>
                <Text style={[commonStyles.darkGrayColor, commonStyles.heading6, commonFontStyles.workSans]}>Rows per page: {rowItems}</Text>
              </View>
              <View style={[commonStyles.displayingItem]}>
                <Text style={[commonStyles.darkGrayColor, commonStyles.heading6, commonFontStyles.workSans]}>Displaying item {startIndex}-{endIndex} of {totalRows}</Text>
              </View>
            </View>
            : null}
        </>
      );
    }
  }
);
